/* global _paq */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { setSelectedCountry } from '../../modules/App/AppState';

import ChartWrapper from '../../components/ChartWrapper';
import CountrySelect from '../CountrySelect';

import './chartSection.styl';

class ChartSection extends PureComponent {
  onCountrySelectChange = (evt) => {
    this.props.dispatch(setSelectedCountry(evt.target.value));
    _paq.push(['trackEvent', 'country_change', evt.target.value, 'Schichtwechsel in Europa']);
  }

  render() {
    return (
      <div className="chart-section">
        <div className="chart__controls">
          <div className="control__section left">
            <span className="control__country">{this.context.getCountryLabel(this.props.referenceCountry)}</span>
          </div>
          <div className="control__section center">
            <span className="control__yAxislabel">{this.props.translate('chart.yAxisLabel')}</span>
          </div>
          <div className="control__section right">
            <CountrySelect
              activeItem={this.props.selectedCountry}
              items={this.props.countries.filter(country => country.Country_Code !== this.props.referenceCountry)}
              onChange={this.onCountrySelectChange}
              currentLanguage={this.props.currentLanguage}
            />
          </div>
        </div>
        <ChartWrapper
          data={this.props.chartData}
          referenceCountry={this.props.referenceCountry}
          selectedCountry={this.props.selectedCountry}
          budget={this.props.budget}
          translate={this.props.translate}
          currentLanguage={this.props.currentLanguage}
        />
        <div className="xAxis__legend">
          {this.props.translate('chart.xAxisLegend')}
        </div>
      </div>
    );
  }
}

ChartSection.contextTypes = {
  getCountryLabel: PropTypes.func
};


export default ChartSection;



// WEBPACK FOOTER //
// ./src/components/ChartSection/index.js